import React from 'react'
import { connect } from "react-redux";
import withStyles from '@material-ui/core/styles/withStyles'
import PurchaseStyles from './PurchaseStyles';
import { Container, Divider, Grid } from '@material-ui/core'
import { FormatNumberMXN } from '../common/Utils';

const PurchaseOrderDetailClientInformation = ({ classes, isInvoice = false, ...props }) => {

    return (
        <Container>
            <Grid item xs={12} className={classes.alignCenter}>
                <Grid item xs={12} className={classes.alignCenter}>
                    <h5>Información de entrega</h5>
                </Grid>
                <Grid container className={classes.containerWithBorderRound}>
                    <Grid item xs={12} className={classes.gridColor1}>
                        <h5 className={classes.textColorWhite}>Información del cliente</h5>
                    </Grid>
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={6} >
                            <h5>&nbsp;&nbsp;Cliente</h5>
                        </Grid>
                        <Grid item xs={6} className={classes.alignCenter}>
                            <h5>{props.orderDetail.client ?? props.orderDetail.client}</h5>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={6}>
                            <h5>&nbsp;&nbsp;Nombre del usuario</h5>
                        </Grid>
                        <Grid item xs={6} className={classes.alignCenter}>
                            <h5>{props.orderDetail.clientUser ?? props.orderDetail.clientUser}</h5>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={6}>
                            <h5>&nbsp;&nbsp;Tel Usuario</h5>
                        </Grid>
                        <Grid item xs={6} className={classes.alignCenter}>
                            <h5>{props.orderDetail.telephoneUser !== "" ? props.orderDetail.telephoneUser : "-"}</h5>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={6}>
                            <h5>&nbsp;&nbsp;Persona que recibe</h5>
                        </Grid>
                        <Grid item xs={6} className={classes.alignCenter}>
                            <h5>{props.orderDetail.personWhoReceives ?? props.orderDetail.personWhoReceives}</h5>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={6}>
                            <h5>&nbsp;&nbsp;Tel contacto</h5>
                        </Grid>
                        <Grid item xs={6} className={classes.alignCenter}>
                            <h5>{props.orderDetail.telephoneContact !== "" ? props.orderDetail.telephoneContact : "-"}</h5>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={6}>
                            <h5>&nbsp;&nbsp;Dirección</h5>
                        </Grid>
                        <Grid item xs={6} className={classes.alignCenter}>
                            <h5>{props.orderDetail.deliveryAddress ?? props.orderDetail.deliveryAddress}</h5>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container className={classes.containerWithBorderRound}>
                    <Grid item xs={12} className={classes.gridColor1}>
                        <h5 className={classes.textColorWhite}>Información del automóvil</h5>
                    </Grid>
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={6} >
                            <h5>&nbsp;&nbsp;&nbsp;Precio</h5>
                        </Grid>
                        <Grid item xs={6} className={classes.alignCenter}>
                            <h5>{props.orderDetail.finalPriceWithoutIva ? FormatNumberMXN(props.orderDetail.finalPriceWithoutIva) : '-'}</h5>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={6}>
                            <h5>&nbsp;&nbsp;&nbsp;IVA</h5>
                        </Grid>
                        <Grid item xs={6} className={classes.alignCenter}>
                            <h5>{props.orderDetail.ivaFinalPrice ? FormatNumberMXN(props.orderDetail.ivaFinalPrice) : '-'}</h5>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={12}>
                            <Divider variant="middle" />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={6}>
                            <h5>&nbsp;&nbsp;&nbsp;Precio con IVA</h5>
                        </Grid>
                        <Grid item xs={6} className={classes.alignCenter}>
                            <h5>{props.orderDetail.finalPrice ? FormatNumberMXN(props.orderDetail.finalPrice) : '-'}</h5>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container className={classes.containerWithBorderRound}>
                    <Grid item xs={12} className={classes.gridColor1}>
                        <h5 className={classes.textColorWhite}>Características del automóvil</h5>
                    </Grid>
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={6} >
                            <h5>&nbsp;&nbsp;&nbsp;Color exterior (primera opción)</h5>
                        </Grid>
                        <Grid item xs={6} className={classes.alignCenter}>
                            <h5>{props.orderDetail.external ?? props.orderDetail.external}</h5>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={3}>
                        <Grid item xs={6}>
                            <h5>&nbsp;&nbsp;&nbsp;Color interior (primera opción)</h5>
                        </Grid>
                        <Grid item xs={6} className={classes.alignCenter}>
                            <h5>{props.orderDetail.internal ?? props.orderDetail.internal}</h5>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container className={classes.containerWithBorderRound}>
                    <Grid item xs={12} className={classes.gridColor1}>
                        <h5 className={classes.textColorWhite}>Accesorios del automóvil</h5>
                    </Grid>
                    {
                        props.orderDetail.accesories && (
                            <Grid container item xs={12} spacing={3}>
                                <Grid item xs={6} className={classes.alignCenter}>
                                    <h5>Accesorio</h5>
                                </Grid>
                                <Grid item xs={6} className={classes.alignCenter}>
                                    <h5>Precio con IVA</h5>
                                </Grid>
                            </Grid>
                        )
                    }
                    {
                        props.orderDetail.accesories && props.orderDetail.accesories.map((accessory, index) => {
                            return (
                                <Grid key={index} container item xs={12} spacing={3}>
                                    <Grid item xs={6} className={classes.alignCenter}>
                                        <h5>{accessory.description}</h5>
                                    </Grid>
                                    <Grid item xs={6} className={classes.alignCenter}>
                                        <h5>{accessory.amount ? FormatNumberMXN(accessory.amount) : '-'}</h5>
                                    </Grid>
                                </Grid>
                            )
                        }
                        )
                    }
                </Grid>
            </Grid>
        </Container>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language,
    navList: state.NavigationReducer.routeList
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(PurchaseStyles)(PurchaseOrderDetailClientInformation))